// extracted by mini-css-extract-plugin
export default {"buttonLight":"buttonLight_buttonLight__QYMua"};